import React, { forwardRef, useRef } from 'react';
import styled from 'styled-components';
import fonts from 'src/integration/styles/fonts';
import colors from 'src/integration/styles/colors';
import Icon from 'src/presentation/components/ui/Icon';
import { iconCalendar } from 'src/integration/assets/AssetsProvider';

interface ComponentProps {
  value?: string;
  onClick?: () => void;
  className?: string;
}

const Root = styled.div`
  position: relative;
  width: 100%;
  min-width: 300px;
  display: flex;
`;

const IconWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translateY(-50%);
  pointer-events: none;
  display: flex;
  align-items: center;
`;

const StyledInput = styled.input`
  font-family: ${fonts.fontFamily.headings};
  font-size: 18px;
  font-weight: 600;
  line-height: 150%;
  color: ${colors.primaryDarkJungleGreen};
  background-color: ${colors.primaryWhite};
  border: 1px solid ${colors.grey4};
  border-radius: 100px;
  padding: 10px 24px;
  width: 100%;
  cursor: pointer;
  text-align: left;

  &:focus {
    outline: none;
  }
`;

const InputCalendar = forwardRef<HTMLInputElement, ComponentProps>(
  ({ value = '', onClick, className }, ref) => {
    const inputRef = useRef<HTMLInputElement>(null);

    return (
      <Root>
        <StyledInput
          className={className}
          onClick={onClick}
          ref={inputRef}
          value={value}
          readOnly
          placeholder="Select date"
        />
        <IconWrapper>
          <Icon icon={iconCalendar} size={28} />
        </IconWrapper>
      </Root>
    );
  }
);

InputCalendar.displayName = 'InputCalendar';

export default InputCalendar;
